import { Col, Form, Row } from "react-bootstrap";

interface IEpaField {
  label: string;
}

const EpaFieldEmpty = ({ label }: IEpaField) => {
  const labelClassName = "col-4 col-md-4";
  const valueClassName = "col-8 col-md-8";

  return (
    <Row>
      <Col className={labelClassName}>
        <Form.Label style={{ color: "#999" }}>{label}</Form.Label>
      </Col>
      <Col className={valueClassName}>{" - "}</Col>
    </Row>
  );
};

export default EpaFieldEmpty;
